import { AppBar, IconButton, Toolbar } from '@mui/material';
import React from 'react';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { ArrowBack } from '@mui/icons-material';
import { inject, observer } from 'mobx-react';
import Progress from '../common/Progress';

@inject('commonStore', 'menuStore')
@observer
class Notation extends Component {
  async componentDidMount() {
    const { commonStore, match } = this.props;

    commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);
  }

  render() {
    const { menuStore, t } = this.props;
    if (!menuStore.storeData) return <Progress />;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="primary" style={{ boxShadow: 'none', zIndex: 1 }}>
          <Toolbar style={{ minHeight: '60px' }}>
            <IconButton edge="start" color="inherit" onClick={() => this.props.history.goBack()} size="large">
              <ArrowBack />
            </IconButton>
            <div className="title" style={{ flexGrow: 1, textAlign: 'center' }}>
              {t('common.label.commerceInfo')}
            </div>
          </Toolbar>
        </AppBar>
        <div className="notation" dangerouslySetInnerHTML={{ __html: menuStore.storeData.notation }} />
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(Notation));
